import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { asSummaryText } from '../utils-display';
import type { Persona } from '@/types';

interface PersonaDownloadMenuProps {
	persona: Persona;
	name: string;
}

function downloadMarkdownFile(filename: string, content: string) {
	const blob = new Blob([content], { type: 'text/markdown' });
	const url = URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = filename;
	anchor.click();
	URL.revokeObjectURL(url);
}

export function PersonaDownloadMenu({ persona, name }: PersonaDownloadMenuProps) {
	const handleDownloadSummary = () => {
		downloadMarkdownFile(`${name}-summary.md`, asSummaryText(persona.summary) || 'No summary available yet.');
	};

	const handleDownloadExamples = () => {
		const content = persona.examples
			.map((example) => `## Question\n${example.query}\n\n## Answer\n${example.reply}`)
			.join('\n\n');
		downloadMarkdownFile(`${name}-examples.md`, content || 'No examples available yet.');
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant='outline' className='rounded-full gap-1.5 font-normal border-gray-500 shadow-none bg-white'>
					<Download className='size-3.5' />
					Download
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align='end'>
				<DropdownMenuItem onSelect={handleDownloadExamples}>Examples</DropdownMenuItem>
				<DropdownMenuItem onSelect={handleDownloadSummary}>Summary</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
